import { apiSlice } from '..';
import { Identity } from '../generated';

const identitySlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getIdentity: builder.query<Identity, void> ({
            query: () => '/identity/isauthorized?includeAiAccess=false'
        })
    })
});

export const { useLazyGetIdentityQuery } = identitySlice;
export default identitySlice;
